import React from 'react'
import MaterialSymbol from '../material-symbol'

const NotificationsOff = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="notifications_off" {...props} />
))

NotificationsOff.displayName = 'NotificationsOff'

export default NotificationsOff
